import { isBefore, isDate } from 'date-fns'
import { Dispatch } from 'redux'
import { change } from 'redux-form'
import { fireToastWarning } from '../../../actions/toasts/fireToast'
import i18n from '../../../i18n'
import { IFilterRoomsValues } from './withReduxForm'

function callWarning(dispatch: Dispatch) {
  dispatch(
    fireToastWarning(i18n.t('reservation_error_end_date_before_start_date')),
  )
}

export default function(
  values: Partial<IFilterRoomsValues>,
  dispatch: Dispatch,
  props,
  previous: Partial<IFilterRoomsValues>,
) {
  if (!isDate(values.dateTo) || !isBefore(values.dateTo, values.dateFrom)) {
    return
  }

  if (!isDate(previous.dateTo) && isBefore(values.dateTo, values.dateFrom)) {
    callWarning(dispatch)
    return dispatch(change('filterRooms', 'dateTo', null))
  }

  if (isDate(previous.dateTo) && isBefore(values.dateTo, values.dateFrom)) {
    const previousDateIsBefore = isBefore(previous.dateTo, values.dateFrom)

    if (previousDateIsBefore) {
      callWarning(dispatch)
      return dispatch(change('filterRooms', 'dateTo', null))
    }
    if (!previousDateIsBefore) {
      callWarning(dispatch)
      return dispatch(change('filterRooms', 'dateTo', previous.dateTo))
    }
  }
}
